module.exports = "<div class=\"input-group input-group-sm\">\n    <span class=\"input-group-btn\">\n        <button class=\"btn btn-tn-primary\" type=\"button\" (click)=\"SearchCode()\"><i class=\"fa fa-search\"></i></button>\n    </span> \n    <input type=\"text\" class=\"form-control \" placeholder=\"Codice Immobile\" [(ngModel)]=\"searchCode\" (keyup.enter)=\"SearchCode()\">\n</div>"


//////////////////
// WEBPACK FOOTER
// A:/Work/Siti/Volpe2/src/app/themes/default/html/tnsearchcode.component.html
// module id = ../../../../../src/app/themes/default/html/tnsearchcode.component.html
// module chunks = 1